<app-promotion *ngIf="promotion" [promotion]="promotion" [isAdmin]="true"></app-promotion>
<app-alert-error [error]="error" [showAppLogo]="true"></app-alert-error>
<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>

